import { ExlyModal } from "features/Common/modules/ExlyModal/ExlyModal";
import { OFFER_DIRECTION } from "../utils/unifiedOffer";
import React from "react";

/**
 * Step-0 chooser (§4.1). Two-card fork setting internal Direction.
 * Matches the Exly "Choose page type" modal style: centered icon cards,
 * indigo selection ring + check badge, footer note, full-width Continue.
 * Tailwind only (border stays 2px in both states so cards never shift).
 */
const OPTIONS = [
  {
    value: OFFER_DIRECTION.DISCOUNT,
    title: "Early Bird Offer",
    description: "Give customers a discount for booking early or acting fast.",
    glyph: "%",
    glyphClass: "tw-text-[#493ab1] tw-bg-[#eceafd]",
  },
  {
    value: OFFER_DIRECTION.SURGE,
    title: "Surge Pricing",
    description:
      "Increase price automatically as seats fill, stock runs low, or demand grows.",
    glyph: "↗",
    glyphClass: "tw-text-[#9a6a1b] tw-bg-[#fdf3e3]",
  },
];

const OfferTypeChooser = ({
  open,
  onClose,
  onContinue,
  initial = OFFER_DIRECTION.DISCOUNT,
}) => {
  const [selected, setSelected] = React.useState(initial);

  React.useEffect(() => {
    if (open) setSelected(initial);
  }, [open, initial]);

  return (
    <ExlyModal
      open={open}
      onClose={onClose}
      title="What would you like to create?"
      primaryBtnText="Continue"
      primaryBtnFullWidth
      showSecondaryBtn={false}
      onPrimaryBtnClick={() => onContinue(selected)}
    >
      <div className="tw-grid tw-grid-cols-2 tw-gap-3 tw-py-6">
        {OPTIONS.map((opt) => {
          const active = selected === opt.value;
          return (
            <button
              key={opt.value}
              type="button"
              onClick={() => setSelected(opt.value)}
              className={`tw-relative tw-rounded-xl tw-border-2 tw-border-solid tw-px-3 tw-py-5 tw-text-center tw-transition-all ${
                active
                  ? "tw-border-[#493ab1] tw-bg-[#f8f7fd]"
                  : "tw-border-[#eceeef] tw-bg-white"
              }`}
            >
              {active && (
                <span className="tw-absolute tw-right-2 tw-top-2 tw-flex tw-h-5 tw-w-5 tw-items-center tw-justify-center tw-rounded-full tw-bg-[#493ab1]">
                  <svg
                    viewBox="0 0 24 24"
                    className="tw-h-[13px] tw-w-[13px] tw-fill-none tw-stroke-white"
                    strokeWidth={3}
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <path d="M20 6L9 17l-5-5" />
                  </svg>
                </span>
              )}
              <span
                className={`tw-mx-auto tw-flex tw-h-[52px] tw-w-[52px] tw-items-center tw-justify-center tw-rounded-full tw-text-[22px] tw-font-bold ${opt.glyphClass}`}
              >
                {opt.glyph}
              </span>
              <span className="tw-mt-3 tw-block tw-text-[15px] tw-font-semibold tw-text-gray-900">
                {opt.title}
              </span>
              <span className="tw-mt-1 tw-block tw-text-[12px] tw-leading-5 tw-text-gray-600">
                {opt.description}
              </span>
            </button>
          );
        })}
      </div>
    </ExlyModal>
  );
};

export { OfferTypeChooser };
